<div class="document-viewer">
  <div class="document-viewer__header">
    <div class="document-viewer__title">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
        stroke-width="1.5"
        stroke="currentColor"
      >
        <path
          stroke-linecap="round"
          stroke-linejoin="round"
          d="M19.5 14.25v-2.625a3.375 3.375 0 0 0-3.375-3.375h-1.5A1.125 1.125 0 0 1 13.5 7.125v-1.5a3.375 3.375 0 0 0-3.375-3.375H8.25m2.25 0H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 0 0-9-9Z"
        />
      </svg>
      <span>{{ document.name }}</span>
    </div>
    <div class="document-viewer__actions">
      <button
        class="document-viewer__btn document-viewer__btn--download"
        (click)="downloadFile()"
        title="Descargar"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          stroke-width="1.5"
          stroke="currentColor"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            d="M3 16.5v2.25A2.25 2.25 0 0 0 5.25 21h13.5A2.25 2.25 0 0 0 21 18.75V16.5M16.5 12 12 16.5m0 0L7.5 12m4.5 4.5V3"
          />
        </svg>
      </button>
      <button
        class="document-viewer__btn document-viewer__btn--close"
        (click)="onClose()"
        title="Cerrar"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          stroke-width="1.5"
          stroke="currentColor"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            d="M6 18 18 6M6 6l12 12"
          />
        </svg>
      </button>
    </div>
  </div>

  <div class="document-viewer__content">
    <!-- Loading spinner -->
    <div class="document-viewer__loading" *ngIf="isLoading">
      <div class="spinner"></div>
      <span>Cargando documento...</span>
    </div>

    <!-- Error message -->
    <div class="document-viewer__error" *ngIf="hasError">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
        stroke-width="1.5"
        stroke="currentColor"
      >
        <path
          stroke-linecap="round"
          stroke-linejoin="round"
          d="M12 9v3.75m9-.75a9 9 0 1 1-18 0 9 9 0 0 1 18 0Zm-9 3.75h.008v.008H12v-.008Z"
        />
      </svg>
      <span>No se pudo cargar el documento</span>
      <button class="document-viewer__btn--retry" (click)="downloadFile()">
        Abrir en nueva pestaña
      </button>
    </div>

    <!-- PDF & Office Viewer using ngx-doc-viewer -->
    <ngx-doc-viewer
      *ngIf="(fileType === 'pdf' || fileType === 'office') && !hasError"
      [url]="document.url"
      [viewer]="viewerType"
      (loaded)="onDocumentLoaded()"
      [class.hidden]="isLoading"
    ></ngx-doc-viewer>

    <!-- Image Viewer -->
    <img
      *ngIf="fileType === 'image' && !hasError"
      [src]="document.url"
      [alt]="document.name"
      (load)="onLoad()"
      (error)="onError()"
      [class.hidden]="isLoading"
    />

    <!-- Video Viewer -->
    <video
      *ngIf="fileType === 'video' && !hasError"
      [src]="document.url"
      controls
      (loadeddata)="onLoad()"
      (error)="onError()"
      [class.hidden]="isLoading"
    ></video>

    <!-- Unknown file type -->
    <div
      class="document-viewer__unknown"
      *ngIf="fileType === 'unknown' && !hasError"
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
        stroke-width="1.5"
        stroke="currentColor"
      >
        <path
          stroke-linecap="round"
          stroke-linejoin="round"
          d="M19.5 14.25v-2.625a3.375 3.375 0 0 0-3.375-3.375h-1.5A1.125 1.125 0 0 1 13.5 7.125v-1.5a3.375 3.375 0 0 0-3.375-3.375H8.25m2.25 0H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 0 0-9-9Z"
        />
      </svg>
      <span>Vista previa no disponible para este tipo de archivo</span>
      <button class="document-viewer__btn--retry" (click)="downloadFile()">
        Descargar archivo
      </button>
    </div>
  </div>
</div>
